import { Component, OnInit, inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { THEME_COLORS, LOADING_CONFIG } from './core/constants/branding.constants';
import { AccountService } from './core/services/account.service';
import { BUILD_INFO } from './core/constants/build-info';
import { APP_ACCESS_PATH } from './core/constants/app-access.constants';

@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterOutlet, NgxSpinnerModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly document = inject(DOCUMENT);
  title = 'maresias-painel';

  readonly spinnerConfig = {
    bdColor: THEME_COLORS.OVERLAY_BACKGROUND,
    color: THEME_COLORS.PRIMARY,
    type: LOADING_CONFIG.SPINNER_TYPE,
    size: LOADING_CONFIG.SPINNER_SIZE,
  };

  constructor(private accountService: AccountService) {}

  ngOnInit(): void {
    console.info(`[Maresias] Versão ${BUILD_INFO.version} · Commit ${BUILD_INFO.commit ?? 'local'}`);
    if (this.document.location.pathname !== APP_ACCESS_PATH) {
      this.accountService.initSessionWatch();
    }
  }
}
